// @flow
import { startRequest, finishRequest } from "@store/utils";
import { type EmployeesState } from "@modules/employee/reducer";

export const setLoading = (state: EmployeesState) => () => {
  return {
    ...state,
    employee: {
      ...state.employee,
      employmentDetails: {
        ...startRequest(state.employee.employmentDetails),
      },
    },
  };
};

export const onGetEmployeeRoleSummarySuccess = (state: EmployeesState) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    employee: {
      ...state.employee,
      employmentDetails: {
        ...finishRequest(state.employee.employmentDetails),
        roleSummary: payload,
      },
    },
  };
};

export const onGetEmployeeRoleSummaryError = (state: EmployeesState) => ({ payload }: Object) => {
  return {
    ...state,
    error: payload,
    employee: {
      ...state.employee,
      employmentDetails: {
        ...finishRequest(state.employee.employmentDetails),
        roleSummary: {
          ...state.employee.employmentDetails.roleSummary,
          content: [],
        },
      },
    },
  };
};

export const onGetEmployeePositionSchemaSuccess = (state: EmployeesState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    employee: {
      ...state.employee,
      employmentDetails: {
        ...finishRequest(state.employee.employmentDetails),
        schema: {
          ...state.employee.employmentDetails.schema,
          employeePosition: payload,
        },
      },
    },
  };
};

export const onGetEmployeePositionSchemaError = (state: EmployeesState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    error: payload,
    employee: {
      ...state.employee,
      employmentDetails: {
        ...finishRequest(state.employee.employmentDetails),
      },
    },
  };
};

export const onUpdateEmployeePositionSuccess = (state: EmployeesState) => () => {
  return {
    ...state,
    employee: {
      ...state.employee,
      employmentDetails: {
        ...finishRequest(state.employee.employmentDetails),
      },
    },
  };
};

export const onUpdateEmployeePositionError = (state: EmployeesState) => ({ payload }: Object) => {
  return {
    ...state,
    error: payload,
    employee: {
      ...state.employee,
      employmentDetails: {
        ...finishRequest(state.employee.employmentDetails),
      },
    },
  };
};

export const onToggleAddEmployeePositionModal = (state: EmployeesState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    employee: {
      ...state.employee,
      employmentDetails: {
        ...state.employee.employmentDetails,
        modals: {
          ...state.employee.employmentDetails.modals,
          addPosition: {
            ...state.employee.employmentDetails.modals.addPosition,
            visible: payload,
          },
        },
      },
    },
  };
};

export const onToggleEditEmployeePositionModal = (state: EmployeesState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    employee: {
      ...state.employee,
      employmentDetails: {
        ...finishRequest(state.employee.employmentDetails),
        modals: {
          ...state.employee.employmentDetails.modals,
          editPosition: {
            visible: payload.visible,
            formData: payload.formData,
          },
        },
      },
    },
  };
};

export const onGetEmployeePositionChangelogSuccess = (state: EmployeesState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    error: null,
    employee: {
      ...state.employee,
      employmentDetails: {
        ...finishRequest(state.employee.employmentDetails),
        changelog: {
          ...state.employee.employmentDetails.changelog,
          list: payload,
        },
      },
    },
  };
};

export const onGetEmployeePositionChangelogError = (state: EmployeesState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    error: payload,
    employee: {
      ...state.employee,
      employmentDetails: {
        ...finishRequest(state.employee.employmentDetails),
        changelog: {
          ...state.employee.employmentDetails.changelog,
          list: {
            ...state.employee.employmentDetails.changelog.list,
            content: [],
          },
        },
      },
    },
  };
};

export const onGetEmployeeSpecialContactsSuccess = (state: EmployeesState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    error: null,
    employee: {
      ...state.employee,
      employmentDetails: {
        ...finishRequest(state.employee.employmentDetails),
        specialContacts: payload,
      },
    },
  };
};

export const onGetEmployeeSpecialContactsError = (state: EmployeesState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    error: payload,
    employee: {
      ...state.employee,
      employmentDetails: {
        ...finishRequest(state.employee.employmentDetails),
      },
    },
  };
};

export const onToggleDeleteEmployeeSpecialContactsModal = (state: EmployeesState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    employee: {
      ...state.employee,
      employmentDetails: {
        ...finishRequest(state.employee.employmentDetails),
        modals: {
          ...state.employee.employmentDetails.modals,
          deleteSpecialContacts: payload,
        },
      },
    },
  };
};
